import { render, staticRenderFns } from "./BuyerInvitedSuppliers.vue?vue&type=template&id=6c0c3f14&scoped=true&"
import script from "./BuyerInvitedSuppliers.vue?vue&type=script&lang=js&"
export * from "./BuyerInvitedSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./BuyerInvitedSuppliers.vue?vue&type=style&index=0&id=6c0c3f14&lang=scss&scoped=true&"
import style1 from "./BuyerInvitedSuppliers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c3f14",
  null
  
)

export default component.exports